import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/RenewalModal.css"

const RenewalPage = ({ renewals, setRenewals }) => {
  const { renewalId } = useParams();
  const navigate = useNavigate();

  const renewal = renewals.find((r) => r.id === parseInt(renewalId));

  if (!renewal) {
    return <p>Renewal not found!</p>;
  }

  const handleDelete = () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this renewal?");
    if (!confirmDelete) return;

    const updatedRenewals = renewals.filter((r) => r.id !== parseInt(renewalId));
    setRenewals(updatedRenewals);
    navigate(-1);
  };

  return (
<div className="renewal-page">
  <h2>Renewal Details</h2>

  <div className="renewal-detail">
    <strong>Renewal Date</strong>
    <span>{renewal.renewal_date}</span>
  </div>

  <div className="renewal-detail">
    <strong>Next Renewal Date</strong>
    <span>{renewal.next_renewal_date}</span>
  </div>

  <a
    href={renewal.policy_document}
    target="_blank"
    rel="noopener noreferrer"
    className="renewal-doc"
  >
    📄 Policy Document
  </a>

  <button className="delete-renewal-btn" onClick={handleDelete}>
    🗑 Delete Renewal
  </button>
</div>

  );
};

export default RenewalPage;